import { Component, Input, OnInit } from '@angular/core';
import { Dictionary } from '../../../../types/dictionary.type';
import { ComponentConfiguration } from '../../models/component-config.model';
import { OrderPaidDateViewComponent } from '../order-paid-date-view/order-paid-date-view.component';
import { OrderPaymentDetailsViewComponent } from '../order-payment-details-view/order-payment-details-view.component';
import { OrderStatusModernViewComponent } from '../order-status-modern-view/order-status-modern-view.component';
import { PriceDetailsViewComponent } from '../price-details-view/price-details-view.component';

export type PriceDetailsItems = 'price'
  | 'orderStatus'
  | 'paymentStatus'
  | 'paidDate'
  ;
@Component({
  selector: 'app-order-price-details-view',
  templateUrl: './order-price-details-view.component.html',
  styleUrls: ['./order-price-details-view.component.scss'],
})
export class OrderPriceDetailsViewComponent implements OnInit {
  @Input() price: string;
  @Input() paymentMethod: string;
  @Input() orderStatus: string;
  @Input() suggestedPrice: string;
  @Input() paidDate: string;

  @Input() paymentStatus: string;
  @Input() createdByAdmin: boolean;

  @Input() config: Dictionary<PriceDetailsItems, PriceDetailsModel> = {};
  items: PriceDetailsModel[] = [];

  getConfig = (config: Dictionary<PriceDetailsItems, PriceDetailsModel>) => ({
    price: {
      config: {
        componentConfig: <ComponentConfiguration>{ componentType: PriceDetailsViewComponent, withParseData: true },
        icon: 'price-crt',
        withIcon: true,
        classes: ['item__description ms-3'],
        isDisplayed: true,
        ...(config.price && config.price.config || {}),
      },
    },
    orderStatus: {
      config: {
        componentConfig: <ComponentConfiguration>{ componentType: OrderStatusModernViewComponent, withParseData: true, },
        icon: 'order-status-crt',
        withIcon: true,
        classes: ['item__description ms-3'],
        isDisplayed: true,
        ...(config.orderStatus && config.orderStatus.config || {}),
      },
    },
    paymentStatus: {
      config: {
        componentConfig: <ComponentConfiguration>{ componentType: OrderPaymentDetailsViewComponent, withParseData: true, },
        withIcon: false,
        classes: ['item__description'],
        isDisplayed: true,
        ...(config.paymentStatus && config.paymentStatus.config || {}),
      },
    },
    paidDate: {
      config: {
        componentConfig: <ComponentConfiguration>{ componentType: OrderPaidDateViewComponent, withParseData: true, },
        withIcon: false,
        classes: ['item__description'],
        isDisplayed: true,
        ...(config.paidDate && config.paidDate.config || {}),
      },
    },
  })

  ngOnInit() {
    this.config = this.getConfig(this.config);

    this.config['price'].model = {
      price: this.price,
      suggestedPrice: this.suggestedPrice,
      paymentMethod: this.paymentMethod,
    };

    this.config['orderStatus'].model = {
      orderStatus: this.orderStatus
    };

    const paymentStatusConfig = this.config['paymentStatus'];
    paymentStatusConfig.model = this.paymentStatus && {
      paymentStatus: this.paymentStatus,
      createdByAdmin: this.createdByAdmin
    } || undefined;

    paymentStatusConfig.config.isDisplayed = paymentStatusConfig.model && paymentStatusConfig.config.isDisplayed;

    this.config['paidDate'].model = this.paidDate && {
      paidDate: this.paidDate
    } || undefined;

    this.items = Object.values(this.config).filter(x => x.config.isDisplayed);
  }
}

export class PriceDetailsModel {
  model?: unknown;
  config: PriceDetailsConfiguration;
}

class PriceDetailsConfiguration {
  icon?: string;
  withIcon: boolean;
  isDisplayed: boolean;
  isLate?: boolean;
  componentConfig: ComponentConfiguration;
}


